import { TextSplitter } from '../vendors/textSplitter.js';
import { gsap } from "gsap";

export default el => {
    const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame;

    const splitter = new TextSplitter(el, {
        resizeCallback: () => { },
        splitTypeTypes: 'lines, words'
    });

    const words = splitter.getWords();
    
    gsap.set(words, {
        y: '100%',
        willChange: 'transform'
    });

    const observer = new IntersectionObserver(
        entries => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                raf(() => {
                    gsap.fromTo(words, {
                        y: '100%'
                    }, {
                        ease: "power3.out",
                        y: '0',
                        stagger: 0.04,
                        duration: 0.8,
                        onComplete: () => {
                            words.forEach(word => {
                                word.style.willChange = 'auto';
                            });
                        }
                    });
                });

                observer.unobserve(el);
                observer.disconnect();
            }
        },
        { 
            rootMargin: '0px 0px -100px 0px',
            threshold: 0.1
        }
    );
    
    observer.observe(el);
}